import axios from 'axios';

export default {
    get: async () => {
        let response;
        response = await axios.get('https://us-central1-flappy-sack.cloudfunctions.net/api/scores?name=name');
        return response.data
    },
    create: async (payload) => {
        let response;
        response = await axios.post('https://us-central1-flappy-sack.cloudfunctions.net/api/score', payload);
        return response.data
    },
    v2: {
        create: async (payload) => {
            let response;
            response = await axios.post('https://us-central1-flappy-sack.cloudfunctions.net/api/v2/score', payload);
            return response.data
        },
        get: {
            top: async () => {
                let response;
                response = await axios.get('https://us-central1-flappy-sack.cloudfunctions.net/api/v2/scores?type=top');
                return response.data
            },
            date: async (date) => {
                let response;
                response = await axios.get(`https://us-central1-flappy-sack.cloudfunctions.net/api/v2/scores?type=date&date=${date}`);
                return response.data
            },
            level: async (level) => {
                let response;
                response = await axios.get(`https://us-central1-flappy-sack.cloudfunctions.net/api/v2/scores?type=level&level=${level}`);
                return response.data
            }
        }
    }
}